import { InvoiceIcmsCstCsosn } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { Select, SelectProps } from 'antd';
import { forwardRef, useMemo } from 'react';

export const taxesIcmsCsosnOptions = [
  {
    value: InvoiceIcmsCstCsosn.TAXATION_UNDER_SIMPLES_WITH_CREDIT_PERMISSION,
    label: '101',
  },
  {
    value: InvoiceIcmsCstCsosn.TAXATION_UNDER_SIMPLES_WITHOUT_CREDIT_PERMISSION,
    label: '102',
  },
  {
    value: InvoiceIcmsCstCsosn.ICMS_EXEMPTION_UNDER_SIMPLES_FOR_GROSS_REVENUE,
    label: '103',
  },
  {
    value:
      InvoiceIcmsCstCsosn.SIMPLES_NACIONAL_WITH_CREDIT_PERMISSION_AND_ICMS_BY_TAX_SUBSTITUTION,
    label: '201',
  },
  {
    value:
      InvoiceIcmsCstCsosn.SIMPLES_NACIONAL_WITHOUT_CREDIT_PERMISSION_AND_WITH_ICMS_CHARGED_BY_TAX_SUBSTITUTION,
    label: '202',
  },
  {
    value:
      InvoiceIcmsCstCsosn.ICMS_EXEMPTION_UNDER_SIMPLES_FOR_GROSS_REVENUE_RANGE_AND_WITH_ICMS_CHARGED_BY_TAX_SUBSTITUTION,
    label: '203',
  },
  { value: InvoiceIcmsCstCsosn.IMMUNITY, label: '300' },
  { value: InvoiceIcmsCstCsosn.NOT_TAXED_UNDER_SIMPLES, label: '400' },
  {
    value: InvoiceIcmsCstCsosn.ICMS_PREVIOUSLY_CHARGED_BY_TAX_SUBSTITUTION,
    label: '500',
  },
  { value: InvoiceIcmsCstCsosn.CSOSN_OTHERS, label: '900' },
];

export const taxesMeiOptions = ['102', '103', '300', '400', '900'];

interface TaxeIcmsCsosnSelectProps extends SelectProps {
  isMei?: boolean;
}

const TaxeIcmsCsosnSelect = forwardRef<BaseSelectRef, TaxeIcmsCsosnSelectProps>(
  ({ isMei = false, ...props }, ref) => {
    const filteredOptions = useMemo(
      () =>
        isMei
          ? taxesIcmsCsosnOptions.filter((option) =>
              taxesMeiOptions.includes(option.label),
            )
          : taxesIcmsCsosnOptions,
      [isMei],
    );

    return (
      <Select
        {...props}
        showSearch
        optionFilterProp="label"
        ref={ref}
        options={filteredOptions}
      />
    );
  },
);

export default TaxeIcmsCsosnSelect;
